import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTransactions } from '../hooks';
import TransactionList from '../components/TransactionList';

const Transactions: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [initialSearchTerm, setInitialSearchTerm] = useState('');
  
  const { 
    transactions, 
    loading, 
    addTransaction, 
    editTransaction, 
    removeTransaction 
  } = useTransactions();

  // Récupérer le terme de recherche depuis l'URL
  useEffect(() => {
    const searchFromUrl = searchParams.get('search');
    if (searchFromUrl) {
      setInitialSearchTerm(searchFromUrl);
    }
  }, [searchParams]);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-h1 text-white">Transactions</h1>
        <p className="text-body-sm text-dark-400 mt-1">
          Gérez vos transactions financières
        </p>
      </div>
      
      <TransactionList
        transactions={transactions}
        loading={loading}
        onAddTransaction={addTransaction}
        onEditTransaction={editTransaction}
        onDeleteTransaction={removeTransaction}
        initialSearchTerm={initialSearchTerm}
      />
    </div>
  );
};

export default Transactions;
